export const apps = [
  {
    id: "joshy",
    name: "Joshy",
    tagline: "AI Booking Assistant for Vancouver",
    shortDescription: "Book restaurant reservations first, then find nearby parking, events, services, and recreation in one chat.",
    description: "Joshy is an AI booking assistant by Aaron DPenha and The App Fam. It focuses first on Vancouver restaurant reservations, then helps with nearby parking, dining guidance, free events, services, and recreation discovery in the same chat.",
    features: [
      "Restaurant reservation help in Vancouver",
      "Nearby parking and dining guidance",
      "Free events and recreation discovery",
      "Local services surfaced through chat",
      "Built to move from intent to booking"
    ],
    idealFor: "Vancouver locals and visitors planning meals, dates, outings, and local errands",
    image: "https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?w=800&auto=format&fit=crop&q=80",
    iconImage: "/app-icons/hey-josh.png",
    websiteUrl: "https://www.getjoshy.com",
    landingPath: "/joshy",
    appStoreUrl: null,
    privacyUrl: "/privacy/joshy"
  },
  {
    id: "scribemind",
    name: "ScribeMind",
    tagline: "Your Study Partner",
    shortDescription: "Record lectures and ideas, then turn them into smart notes, summaries, and lecture-based exams.",
    description: "ScribeMind is an AI study partner by Aaron DPenha and The App Fam. It records lectures and ideas, transcribes them, summarizes key points, and creates lecture-based exams so students and professionals can learn faster.",
    features: [
      "Lecture and idea recording",
      "AI-powered transcription and summaries",
      "Structured notes from class content",
      "Lecture-based exams and study checks",
      "Built for faster review and retention"
    ],
    idealFor: "Students, online learners, professionals, and lifelong learners",
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&auto=format&fit=crop&q=80",
    iconImage: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4e/7e/70/4e7e701b-b155-7555-9ad5-272d142b325c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.png",
    appStoreUrl: "https://apps.apple.com/ca/app/scribemind/id6758567211",
    landingPath: "/scribemind",
    privacyUrl: "/privacy/scribemind"
  },
  {
    id: "selah-daily",
    name: "Selah Daily",
    tagline: "Remember, Reflect, Return",
    shortDescription: "Record sermons, get instant summaries, and turn each message into a five-day devotional rhythm.",
    description: "Selah Daily is a devotional app by Aaron DPenha and The App Fam. It helps believers record sermons, generate transcripts and summaries, create five-day devotionals, follow guided prayer, and build consistent spiritual habits.",
    features: [
      "Sermon recording and transcription",
      "AI-generated sermon summaries",
      "Five-day devotional plans",
      "Guided prayer wall and daily reminders",
      "Bible reading, bookmarks, and translations"
    ],
    idealFor: "Church members, pastors, small groups, and believers building a daily rhythm",
    image: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=800&auto=format&fit=crop&q=80",
    iconImage: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/47/0c/3c/470c3c27-5941-665f-1975-a68794e925e8/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/512x512bb.png",
    appStoreUrl: "https://apps.apple.com/ca/app/selah-daily/id6758280709",
    landingPath: "/selah-daily",
    privacyUrl: "/privacy/selah-daily"
  }
];
